export default "__VITE_ASSET__DwlOqqtX__"